/**
 * demoScope.js — Escopo da demo (redução de funcionalidades não prontas)
 *
 * Config CENTRAL: itens fora do escopo inicial da demo VUKZ (jul/2026).
 * NADA aqui substitui RBAC — decorators backend permanecem intactos.
 * Reativação futura: REACT_APP_FULL_SCOPE=true restaura tudo.
 *
 * Ver: arenastats-backend/docs/demo/DEMO_GAP_BACKLOG.md
 */

/** Escopo reduzido ativo por padrão; REACT_APP_FULL_SCOPE=true desliga. */
export const DEMO_SCOPE_ENABLED = process.env.REACT_APP_FULL_SCOPE !== 'true';

/** Nav IDs (sidebarConfig) retirados do escopo inicial. */
export const OUT_OF_SCOPE_NAV_IDS = new Set([
  // Mensagens (chat sem backend de dados)
  'nav-athlete-messages',
  'nav-coach-messages',
  'nav-prep-messages',
  'nav-manager-messages',
  // Gestor
  'nav-manager-interventions',
  'nav-manager-strategic-plan',
  'nav-manager-claim',      // Dados Oficiais
  'nav-manager-roster',     // Elenco & Staff (substituído por Categorias + Staff)
  'nav-manager-staff-permissions', // Escopo do Staff — removido da Administração (gate final: Staff já cobre)
  // Treinador — gate final demo (jul/2026): nav simplificada.
  // Rotas/componentes/permissões permanecem dormentes p/ reativação futura.
  'nav-coach-treino-fisico',    // Treino Físico (leitura continua via Treino dos atletas)
  'nav-coach-my-performance',   // Performance Atletas
  // Inteligência
  'nav-stats-swimming',     // Rankings Natação
  'nav-competition-results' // Competições
]);

/** Prefixos de rota bloqueados — guard redireciona p/ home da role sem montar componente. */
export const OUT_OF_SCOPE_ROUTE_PREFIXES = [
  '/chat',
  '/manager/chat',
  '/manager/interventions',
  '/manager/plan',
  '/manager/strategic-plan',
  '/manager/claim',
  '/natacao/rankings',
  '/competicoes'
];

/**
 * Rotas bloqueadas APENAS no match exato.
 * /manager/roster/athlete/:id é o perfil do atleta usado pelo drill-down de
 * Categorias (F3) — continua acessível; só a listagem "Elenco & Staff" sai.
 */
export const OUT_OF_SCOPE_ROUTES_EXACT = ['/manager/roster'];

/**
 * @param {string} pathname
 * @returns {boolean} true se a rota está fora do escopo da demo
 */
export const isRouteOutOfScope = (pathname) => {
  if (!DEMO_SCOPE_ENABLED || !pathname) return false;
  if (OUT_OF_SCOPE_ROUTES_EXACT.includes(pathname)) return true;
  return OUT_OF_SCOPE_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
};

/**
 * @param {string} navId
 * @returns {boolean} true se o item de menu está fora do escopo da demo
 */
export const isNavItemOutOfScope = (navId) =>
  DEMO_SCOPE_ENABLED && OUT_OF_SCOPE_NAV_IDS.has(navId);
